import { Plus, Trash2, X } from "lucide-react";

export default function PlanEditor({
  plan,
  pIdx,
  onPatch,
  onRemove,
  onAddMilestone,
  onRemoveMilestone,
  onUpdateMilestone,
}) {
  const sum = (plan.milestones || []).reduce(
    (s, m) => s + (parseFloat(m.percent) || 0),
    0,
  );
  return (
    <div
      className="rounded-xl border border-white/10 bg-white/[0.02] p-3 space-y-3"
      data-testid={`payment-plan-row-${pIdx}`}
    >
      <div className="flex items-center gap-2">
        <input
          className="input-luxe !h-9 !py-1 flex-1 font-display font-semibold"
          value={plan.name || ""}
          onChange={(e) => onPatch({ name: e.target.value })}
          placeholder="Plan name"
          maxLength={60}
          data-testid={`payment-plan-name-${pIdx}`}
        />
        <button
          onClick={onRemove}
          className="p-1.5 rounded text-red-300/70 hover:text-red-300"
          title="Remove plan"
          data-testid={`payment-plan-remove-${pIdx}`}
        >
          <Trash2 size={14} />
        </button>
      </div>
      <textarea
        className="input-luxe !h-14 !py-2 leading-snug resize-none"
        value={plan.description || ""}
        onChange={(e) => onPatch({ description: e.target.value })}
        placeholder="Short description (e.g. 'Default 50/30/20')"
        maxLength={240}
        rows={2}
        data-testid={`payment-plan-desc-${pIdx}`}
      />
      <div className="space-y-2">
        {(plan.milestones || []).map((m, mIdx) => (
          <div
            key={m._key || mIdx}
            className="grid grid-cols-[1fr_72px_auto] gap-2 items-start"
            data-testid={`payment-plan-${pIdx}-milestone-${mIdx}`}
          >
            <div className="space-y-1">
              <input
                className="input-luxe !h-9 !py-1"
                value={m.label || ""}
                onChange={(e) => onUpdateMilestone(mIdx, { label: e.target.value })}
                placeholder="Milestone label"
                maxLength={80}
                data-testid={`payment-plan-${pIdx}-milestone-${mIdx}-label`}
              />
              <input
                className="input-luxe !h-8 !py-1 !text-[11px] text-white/70"
                value={m.note || ""}
                onChange={(e) => onUpdateMilestone(mIdx, { note: e.target.value })}
                placeholder="Note (optional)"
                maxLength={160}
                data-testid={`payment-plan-${pIdx}-milestone-${mIdx}-note`}
              />
            </div>
            <div className="flex items-center gap-1">
              <input
                type="number"
                inputMode="decimal"
                className="input-luxe !h-9 !py-1 text-right"
                value={m.percent ?? 0}
                onChange={(e) => onUpdateMilestone(mIdx, { percent: e.target.value })}
                placeholder="0"
                min="0"
                max="100"
                step="1"
                data-testid={`payment-plan-${pIdx}-milestone-${mIdx}-percent`}
              />
              <span className="text-white/40 text-[11px]">%</span>
            </div>
            <button
              onClick={() => onRemoveMilestone(mIdx)}
              className="p-1.5 rounded text-red-300/60 hover:text-red-300 mt-0.5"
              title="Remove milestone"
              data-testid={`payment-plan-${pIdx}-milestone-${mIdx}-remove`}
            >
              <X size={13} />
            </button>
          </div>
        ))}
        <button
          onClick={onAddMilestone}
          className="btn-ghost !h-9 w-full flex items-center justify-center gap-1 text-xs"
          data-testid={`payment-plan-${pIdx}-add-milestone`}
        >
          <Plus size={13} /> Add milestone
        </button>
      </div>
      <div
        className="text-[11px] text-right"
        style={{
          color: sum > 100 ? "#fca5a5" : sum === 100 ? "var(--primary)" : "rgba(255,255,255,0.5)",
        }}
        data-testid={`payment-plan-${pIdx}-total`}
      >
        Total {sum.toFixed(sum % 1 ? 1 : 0)}%
        {sum > 100 ? " (over 100!)" : sum < 100 ? ` · ${(100 - sum).toFixed(0)}% remaining` : ""}
      </div>
    </div>
  );
}
